import React, { useId } from 'react';
import classNames from 'classnames';

import { useIntl } from '../../../util/reactIntl';

import css from './ScalePointFilter.module.css';

/**
 * FASE2-BUSCADOR-3d — "Mi dato", no un rango.
 *
 * En /compradores quien filtra es un VENDEDOR buscando compradores que encajen
 * con su negocio. Lo que tiene es un dato propio —factura 800.000 €, tiene 12
 * empleados—, no un intervalo. Y lo que busca son mandatos cuyo intervalo
 * CONTENGA ese dato.
 *
 * Por eso un solo control escribe DOS parámetros de URL, que es lo que ningún
 * filtro del template sabe hacer. Eligiendo el tramo k:
 *
 *   pub_<algo>IdxMin = 1,k      el mandato empieza en k o antes
 *   pub_<algo>IdxMax = k,<tope> y termina en k o después
 *
 * Se usan los extremos reales de la escala en vez de dejar el lado abierto,
 * porque el filtro de rango de la API espera los dos valores.
 *
 * Sin estado local: la URL es la fuente de verdad, igual que RangeSelectFilter.
 */
const ScalePointFilter = props => {
  const intl = useIntl();
  const inputId = useId();
  const { label, queryParamNames, initialValues, onSubmit, scale } = props;

  const [minParam, maxParam] = queryParamNames;
  const idxMin = scale[0].idx;
  const idxMax = scale[scale.length - 1].idx;

  // El valor elegido se recupera del extremo SUPERIOR del primer parámetro:
  // "1,4" → 4. Los dos params se escriben juntos, así que basta con uno.
  const raw = initialValues?.[minParam];
  const elegido = raw != null && `${raw}`.includes(',') ? `${raw}`.split(',')[1] : '';
  const isActive = elegido !== '';

  const emit = valor => {
    onSubmit(
      valor === ''
        ? { [minParam]: null, [maxParam]: null }
        : { [minParam]: `${idxMin},${valor}`, [maxParam]: `${valor},${idxMax}` }
    );
  };

  return (
    <div className={css.root}>
      <div className={css.filterHeader}>
        <label htmlFor={inputId} className={classNames(css.label, { [css.labelActive]: isActive })}>
          {label}
        </label>
      </div>
      <select
        id={inputId}
        className={classNames(css.select, { [css.selectPlaceholder]: !isActive })}
        value={elegido}
        onChange={e => emit(e.target.value)}
      >
        <option value="">{intl.formatMessage({ id: 'ScalePointFilter.cualquiera' })}</option>
        {scale.map(tramo => (
          <option key={tramo.idx} value={tramo.idx}>
            {tramo.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ScalePointFilter;
